module.exports = __webpack_public_path__ + "img/my-documents.cdfa06c6.svg";